import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  
  navigate() {
    console.log("clicked")
    window.history.back();
  }
}
